import React from 'react';
import "./index.less"
// 行业动态
// console.log('dongTai-HangYeDongtai2',window.apiObj.hangYeList);
var hangYeList = window.apiObj.hangYeList

class HangYeList extends React.Component {

  render(){
   
    return (
        <div>
          {
            hangYeList.map((item,index)=>{
              return (
                <a key={index} href={'#/detail?page=dongtai&type=news&name=行业动态&title='+item.title}>
                  <div className="dongTaiList" >
                    <div className="img-wrapper">
                      
                        <img width="100%" src="https://vkceyugu.cdn.bspapp.com/VKCEYUGU-734930d7-0782-4082-ab89-dc1d7326b48b/756e9c92-512e-4f9f-a4bf-f6e741e41d116.jpg" alt="" />
                    </div>
                    <div className="content-wrapper">
                      <div className="title ">{item.title}</div>
                      <div className="desc">{item.title}</div>
                      <div className="footer">
                        <div className="date">{item.date}</div>
                        <div className="more-tip">查看详情</div>
                      </div>
                    </div>
                  </div>
                </a>
              )
            })
          }
        
        </div>
      );
  }
}

export default HangYeList;
